<template>
    <v-container fluid>
        <akcd_overview_hdr ref="akcd_overview_hdr" class="mb-2" @updateSelection="updateSelection"/>
        <akcd_overview_lst ref="akcd_overview_lst"/>
    </v-container>
</template>
 
<script>
    import akcd_overview_hdr from "@/components/syst/ref/akcd/akcd_overview_hdr.vue";
    import akcd_overview_lst from "@/components/syst/ref/akcd/akcd_overview_lst.vue";

    export default {
        components: {
            akcd_overview_hdr,
            akcd_overview_lst,
        },    
        data() {
            return {
            }
        },    
        methods: { 
            updateSelection(selectionType, selectionValue) {
                this.$refs.akcd_overview_lst.updateSelection(selectionType, selectionValue);
            },
        }
    }
</script> 

<style scoped> 

</style>